import React from 'react';
import styled from 'styled-components';

import MaterialSymbol from './MaterialSymbol';

const CloseIconStyled = styled(MaterialSymbol)`
  cursor: pointer;
  line-height: 0;
  vertical-align: middle;
  &:hover {
    color: var(--secondaryHover);
  }
`;

type Props = {
  onClick?: () => void;
  color?: 'gray' | 'secondary';
  small?: boolean;
};

export default function CloseIcon({ onClick, color }: Props) {
  return (
    <CloseIconStyled
      icon="close"
      onClick={onClick}
      fontSize="small"
      color={color === 'gray' ? 'var(--gray4c)' : 'var(--secondary)'}
    />
  );
}
